module.exports = __webpack_public_path__ + "img/weChat_img.d15a34e1.png";